import { useTellescopeMutation } from "@tellescope/tanstack-query";
import { Badge } from "@tellescope/ui";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface ReviewButtonCellProps {
  isReviewed: boolean;
  observationIds: string[];
  count?: number;
  canUpdateObservations: boolean;
}

export const ReviewButtonCell = ({
  isReviewed,
  observationIds,
  count,
  canUpdateObservations: canReview,
}: ReviewButtonCellProps) => {
  const { t } = useTranslation("vitals");
  const markReviewedMutation = useTellescopeMutation({
    model: "enduser_observations",
    method: "acknowledge",
  });

  if (isReviewed || !canReview) {
    return (
      <Badge
        variant="outline"
        className={
          isReviewed
            ? "font-normal bg-green-100 text-green-700 border-green-400"
            : "font-normal bg-gray-100 text-muted-foreground"
        }
      >
        {isReviewed && <Check />}
        {isReviewed ? t("Reviewed") : t("Not Reviewed")}
      </Badge>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();

        markReviewedMutation.mutate({
          ids: observationIds,
        });
      }}
    >
      <Badge variant="outline" className="font-normal bg-gray-100 text-muted-foreground hover:bg-gray-200">
        {(count ?? 0) > 1 ? t("Not Reviewed ({{amount}})", { amount: count }) : t("Not Reviewed")}
      </Badge>
    </button>
  );
};
